export default __webpack_public_path__ + "static/media/circle-green-multiple.83cc3798.svg";